import { cubicEaseOut } from '@helpers/animate';
import { imageWrapperPreserveRatio, imageCoverContainer } from '@helpers/image';
import fonts from '@helpers/fonts';
import { h6, tag } from '@helpers/typography';
import styled from 'styled-components';
import SimpleImage from '../SimpleImage/SimpleImage';
const Container = styled.article `
  display: block;
  height: 100%;
`;
const Link = styled.a `
  display: flex;
  border-bottom: 1px solid currentColor;
  color: currentColor;
  flex-direction: column;
  height: 100%;
  padding-bottom: 28px;
  text-decoration: none;
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(340, 195)}
  margin: 0 0 36px;
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer()}
  transform: scale(1);
  transition: transform 1s ${cubicEaseOut};

  ${Link}:focus &, ${Link}:hover & {
    transform: scale(1.1);
  }
`;
const Tag = styled.small `
  ${tag};
  display: block;
  color: var(--accentColor);
  margin: 0 0 20px;
`;
const Title = styled.h3 `
  ${h6};
  margin: 0 0 20px;
  text-decoration: none;
  text-underline-position: under;

  ${Link}:focus &,
  ${Link}:hover & {
    text-decoration: underline;
  }
`;
const Content = styled.p `
  ${fonts.helvetica.regular};
  font-size: 18px;
  letter-spacing: -0.01em;
  line-height: 30px;
  margin: 0 0 48px;
`;
const CtaWrapper = styled.div `
  display: flex;
  align-items: center;
  ${fonts.helvetica.medium};
  font-size: 16px;
  line-height: 1em;
  margin-top: auto;

  svg {
    margin-left: 76px;
    transform: translateX(0px);
    transition: transform 0.15s ${cubicEaseOut};

    ${Link}:focus &,
    ${Link}:hover & {
      transform: translateX(10px);
    }
  }
`;
const MediaCardStyles = {
    Container,
    Content,
    CtaWrapper,
    Image,
    ImageWrapper,
    Link,
    Tag,
    Title,
};
export default MediaCardStyles;
